import React from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';

function Preview(props) {
  const { previewClass, value } = props;

  // Sanitize markdown-generated HTML, but allow more tags for rich markdown content
  const sanitizedHTML = DOMPurify.sanitize(value, {
    ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 'i', 'b', 'blockquote', 'mark',
                   'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol', 'li', 'a',
                   'code', 'pre', 'hr', 'table', 'thead', 'tbody', 'tr', 'th', 'td'],
    ALLOWED_ATTR: ['href', 'target', 'rel'], // Allow links but no event handlers
  });

  /* eslint-disable react/no-danger */
  return (
    <div
      className={`md-editor-preview ${previewClass}`}
      dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
    />
  );
  /* eslint-enable react/no-danger */
}

Preview.propTypes = {
  previewClass: PropTypes.string,
  value: PropTypes.string,
};

Preview.defaultProps = {
  previewClass: '',
  value: undefined,
};

export default Preview;
